import i18n from '@/i18n'
import InitializeApp from '@/modules/InitializeApp'
import CreateFormSheet from '@/modules/form/CreateFormSheet'
import FormPublishSheet from '@/modules/formPublish/FormPublishSheet'
import JPushNotificationListener from '@/modules/session/JPushNotificationListener'
import JPushRegistrationHandler from '@/modules/session/JPushRegistrationHandler'
import { store } from '@/redux/store'
import { NavigationDarkTheme, NavigationLightTheme } from '@/theme'
import { TrueSheetProvider } from '@lodev09/react-native-true-sheet'
import { StatusBar } from 'expo-status-bar'
import { PropsWithChildren } from 'react'
import { I18nextProvider } from 'react-i18next'
import { useColorScheme } from 'nativewind'
import { Platform } from 'react-native'
import 'react-native-reanimated'
import { SafeAreaProvider } from 'react-native-safe-area-context'
import { Provider as ReduxProvider } from 'react-redux'
import { AlertContainer } from '@/components/Alert'
import PrivacyConsentDialog from '@/modules/PrivacyConsentDialog'

export default function RootLayout({ children }: PropsWithChildren) {
  const { colorScheme } = useColorScheme()
  const theme = colorScheme === 'dark' ? NavigationDarkTheme : NavigationLightTheme

  return (
    <I18nextProvider i18n={i18n}>
      <ReduxProvider store={store}>
        <TrueSheetProvider>
          <InitializeApp />
          <JPushRegistrationHandler />
          <JPushNotificationListener />
          {Platform.OS !== 'ios' && <AlertContainer />}
          <SafeAreaProvider
            style={{
              flex: 1,
              backgroundColor: theme.colors.background,
            }}
          >
            <StatusBar style="auto" />
            {children}
          </SafeAreaProvider>
          <CreateFormSheet />
          <FormPublishSheet />
          <PrivacyConsentDialog />
        </TrueSheetProvider>
      </ReduxProvider>
    </I18nextProvider>
  )
}
